import React, { useState, useEffect, useMemo, useCallback } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Row, Col, Card, CardBody, Button, InputGroup, Input, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, FormGroup, Label } from "reactstrap";

import DataTable from "react-data-table-component";

import { Slide, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

//import common page container
import PageContainer from "../Layout/PageContainer";

import styles from "../../assets/subHeader.module.scss";

//import payout service
import payoutService from "../../redux/services/payout.service";

//import common filter component
import FilterComponent from "../../helpers/FilterComponent";

import debounceFunction from "../../helpers/Debounce";
import { convertDate, getDateTimeInCST, getRentelRateByType, getRentelUniPrice, getReservationTypeLabel, getSpaceAdddress, getUserFullName } from "../../helpers/functions";

import IconContainer from "../Common/IconContainer";
import { AiFillEye, AiOutlineComment } from "react-icons/ai";

import PayoutCommentModal from "./components/PayoutCommentModal";

toast.configure();

const PayoutListing = (props) => {
    const navigate = useNavigate();
    const role = props.currentUser.roleId === 1 ? "admin" : "csr";
    const [payouts, setPayouts] = useState([]);
    const [totalPayouts, setTotalPayouts] = useState(0);

    const [perPage, setPerPage] = useState(10);

    const [currentPage, setCurrentPage] = useState(1);

    const [filterText, setFilterText] = useState("");

    // Import modal state
    const [importModalOpen, setImportModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [importing, setImporting] = useState(false);
    const [importResult, setImportResult] = useState(null);

    // Payout comment modal state
    const [commentModalOpen, setCommentModalOpen] = useState(false);
    const [selectedPayout, setSelectedPayout] = useState(null);

    const fetchPayouts = async (keyword, page, perPageObj) => {
        try {
            const response = await payoutService.getPayoutListing(keyword, page, perPageObj);
            if (response && response.data && response.data.data) {
                setPayouts(response.data.data.rows || []);
                setTotalPayouts(response.data.data.count || 0);
            }
        } catch (error) {
            console.error("Error fetching payouts:", error);
            toast.error(error?.response?.data?.message || "Failed to fetch payouts.");
        }
    };

    console.log("payouts", payouts);
    console.log("totalPayouts", totalPayouts);

    useEffect(() => {
        //fetch payouts
        fetchPayouts(filterText, 1, perPage);
    }, []);

    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

    const debounceSearch = useCallback(
        debounceFunction((nextValue) => {
            fetchPayouts(nextValue, 1, perPage);
        }, 1000),
        [perPage]
    );

    const handleExport = async () => {
        try {
            if (role === "admin") {
                const response = await payoutService.exportPayoutListing();

                const blob = new Blob([response.data], { type: "text/csv" });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "refunds_export_" + getDateTimeInCST() + ".csv");

                document.body.appendChild(link);
                link.click();
                link.remove();

                window.URL.revokeObjectURL(url);
            } else {
                toast("Only Admin users are allowed to perform this action!", {
                    transition: Slide,

                    closeButton: true,

                    autoClose: 3000,

                    position: "top-right",

                    type: "error",
                });
            }
        } catch (error) {
            console.error("Export failed", error);
        }
    };

    //subheader component of react-data-table.
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);

                setFilterText("");

                //fetch payouts
                fetchPayouts("", 1, perPage);
            }
        };

        return (
            <div className="w-100 d-flex justify-content-between align-items-center">
                <div style={{ fontWeight: 600, fontSize: "1.1rem" }}>
                    Payout Listing
                </div>
                <div className="d-flex align-items-center justify-content-end" style={{ width: "60%" }}>
                    <InputGroup size="sm" style={{ width: "250px", marginBottom: 0 }}>
                        <Input
                            id="search"
                            type="text"
                            placeholder="Search..."
                            value={filterText}
                            onChange={(event) => {
                                setFilterText(event.target.value);
                                debounceSearch(event.target.value);
                            }}
                        />
                        <Button color="primary" onClick={handleClear}>
                            <i className="pe-7s-close" style={{ cursor: "pointer", fontWeight: "bold" }}></i>
                        </Button>
                    </InputGroup>
                    
                    {/* Actions - Right Side */}
                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                        <Button
                            color="primary"
                            style={{ marginLeft: "10px", marginBottom: 0 }}
                            onClick={() => {
                                setImportResult(null);
                                setSelectedFile(null);
                                setImportModalOpen(true);
                            }}
                        >
                            + Import Payouts
                        </Button>
                        <Button color="primary" onClick={handleExport} className="me-2 text-nowrap">
                            <i className="pe-7s-cloud-download me-1"></i> Export
                        </Button>
                    </div>
                </div>
            </div>
        );
    }, [filterText, resetPaginationToggle, perPage, debounceSearch]);

    const columns = useMemo(
        () => [
            {
                name: "Reservation Code",
                width: "180px",
                selector: (row) => {
                    return row.Transaction?.Reservation?.reservationCode || "N/A";
                },
                sortable: true,
            },

            {
                name: "Rental Type",
                width: "150px",
                selector: (row) => {
                    return getReservationTypeLabel(row.Transaction?.Reservation?.reservationType) || "N/A";
                },
                sortable: true,
            },
            {
                name: "Address",
                selector: (row) => {
                    return (
                        <div className={styles.subHeaderBlock}>
                            <Button
                                className={styles.subHeader__text}
                                color="link"
                                onClick={() => {
                                    navigate(`/space/` + row?.Transaction?.Reservation?.Space?.id);
                                }}
                                style={{ padding: 0 }}
                                title={getSpaceAdddress(row?.Transaction?.Reservation?.Space)}
                            >
                                {getSpaceAdddress(row?.Transaction?.Reservation?.Space)}
                            </Button>

                        </div>
                    );
                },
                width: "300px",
                sortable: true,
            },
            {
                name: "Rate",
                selector: (row) => {
                    return "$" + getRentelUniPrice(row.Transaction?.Reservation);
                },
                sortable: true,
            },
            {
                name: "Quantity",
                selector: (row) => {
                    return row.Transaction?.Reservation?.quantity;
                },
                sortable: true,
            },
            {
                name: "Total Rental Amount",
                width: "150px",
                selector: (row) => {
                    return "$" + row.Transaction?.netAmount;
                },
                sortable: true,
            },
            {
                name: "Payment Date",
                width: "150px",
                selector: (row) => {
                    return convertDate(new Date(row.Transaction?.paymentDate));
                },
                sortable: true,
            },     
            {
                name: "Payment ID",
                width: "250px",
                selector: (row) => {
                    return row.Transaction?.transactionCode;
                },
                sortable: true,

            },
            {
                name: "Host Name",
                selector: (row) => {
                    return getUserFullName(row?.User);
                },
                sortable: true,
                minWidth: "200px",
            },
            {
                name: "Payout Amount",
                width: "150px",
                selector: (row) => {
                    return "$" + row.amount;
                },
                sortable: true,
            },
            {
                name: "Payout Transaction ID",
                width: "235px",
                selector: (row) => {
                    return row.transactionCode;
                },
                sortable: true,
            },
            {
                name: "Payout Type",
                selector: (row) => {
                    return row.payoutType || "Stripe";
                },
                sortable: true,
            },
            {
                name: "Payout Date",
                width: "150px",
                selector: (row) => {
                    return convertDate(new Date(row.paymentDate));
                },
                sortable: true,
            },
            {
                name: "Status",
                selector: (row) => {
                    return row.paymentStatus ? "Paid" : "Failed";
                },
                sortable: true,
            },
            {
                name: "Payout Comment",
                width: "200px",
                selector: (row) => {
                    return row.payoutComment || "-";
                },
            },
            {
                name: "Actions",
                button: true,
                minWidth: "140px",
                cell: (row) => (
                    <div className="d-flex justify-content-center">
                        <IconContainer
                            id={"viewIcon_" + row?.id}
                            Icon={AiFillEye}
                            handleOnClick={() => {
                                navigate(`/payouts/view/${row?.id}`);
                            }}
                            text={"View payout details"}
                        />
                        <IconContainer
                            id={"commentIcon_" + row?.id}
                            Icon={AiOutlineComment}
                            handleOnClick={() => {
                                setSelectedPayout(row);
                                setCommentModalOpen(true);
                            }}
                            text={"Add/Edit payout comment"}
                        />
                    </div>
                ),
            },
        ],
        []
    );

    const handlePageChange = (page) => {
        //fetch payouts
        fetchPayouts(filterText, page, perPage);

        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        //fetch payouts
        fetchPayouts(filterText, page, newPerPage);

        setPerPage(newPerPage);
    };

    const handleDownloadErrors = () => {
        if (!importResult || !importResult.errors) return;

        const csvRows = [
            ["Error Description"], // Header
            ...importResult.errors.map(err => [`"${err.replace(/"/g, '""')}"`]) // Escape quotes
        ];

        const csvContent = csvRows.map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `payout_import_errors_${new Date().getTime()}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <PageContainer
            pageTitleIcon="pe-7s-shopbag icon-gradient bg-plum-plate"
            pageHeading="Payouts"
            pageSubTitle="Listing all the payouts"
        >
            <Row>
                <Col md="12">
                    <Card className="main-card mb-3">
                        <CardBody>
                            <DataTable
                                columns={columns}
                                data={payouts}
                                pagination
                                // paginationPerPage = '25'
                                paginationServer
                                paginationTotalRows={totalPayouts}
                                paginationDefaultPage={currentPage}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                subHeader
                                subHeaderComponent={subHeaderComponent}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            {/* Import CSV Modal */}
            <Modal isOpen={importModalOpen} toggle={() => setImportModalOpen(false)}>
                <ModalHeader toggle={() => setImportModalOpen(false)}>Import Payouts from CSV</ModalHeader>
                <ModalBody>
                    {!importResult ? (
                        <>
                            <p className="mb-3">Upload a CSV file with columns: <strong>reservationCode</strong>, <strong>transactionId</strong>, <strong>amount</strong>, <strong>payoutId</strong>, <strong>payoutType</strong>, <strong>payoutDate</strong></p>
                            <Input
                                id="csvFileInput"
                                type="file"
                                accept=".csv"
                                onChange={(e) => setSelectedFile(e.target.files[0] || null)}
                            />
                        </>
                    ) : (
                        <div>
                            <h5 className="mb-3">Import Results</h5>
                            <div className="d-flex justify-content-around mb-3">
                                <div className="text-center">
                                    <h2 className="text-success mb-0">{importResult.imported}</h2>
                                    <small className="text-muted">Imported</small>
                                </div>
                                <div className="text-center">
                                    <h2 className="text-warning mb-0">{importResult.skipped}</h2>
                                    <small className="text-muted">Skipped</small>
                                </div>
                                <div className="text-center">
                                    <h2 className="mb-0">{importResult.total}</h2>
                                    <small className="text-muted">Total Rows</small>
                                </div>
                            </div>
                            {importResult.errors && importResult.errors.length > 0 && (
                                <div className="mt-2">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <h6 className="mb-0">Errors:</h6>
                                        {importResult.errors.length > 5 && (
                                            <Button color="link" size="sm" className="p-0 text-danger" onClick={handleDownloadErrors}>
                                                Download Error Log
                                            </Button>
                                        )}
                                    </div>
                                    <ul className="text-danger" style={{ fontSize: "0.85rem", maxHeight: "150px", overflowY: "auto" }}>
                                        {importResult.errors.map((err, idx) => (
                                            <li key={idx}>{err}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    {!importResult ? (
                        <>
                            <Button
                                color="primary"
                                disabled={!selectedFile || importing}
                                onClick={async () => {
                                    setImporting(true);
                                    try {
                                        const response = await payoutService.importPayouts(selectedFile);
                                        if (response && response.data && response.data.data) {
                                            setImportResult(response.data.data);
                                            // Refresh the listing
                                            fetchPayouts(filterText, 1, perPage);
                                        }
                                    } catch (error) {
                                        toast.error(error?.response?.data?.message || "Import failed.");
                                    } finally {
                                        setImporting(false);
                                    }
                                }}
                            >
                                {importing ? <><Spinner size="sm" /> Importing...</> : "Upload & Import"}
                            </Button>
                            <Button color="secondary" onClick={() => setImportModalOpen(false)}>
                                Cancel
                            </Button>
                        </>
                    ) : (
                        <Button color="primary" onClick={() => setImportModalOpen(false)}>
                            Close
                        </Button>
                    )}
                </ModalFooter>
            </Modal>
            {/* Payout Comment Modal */}
            <PayoutCommentModal
                isModalOpen={commentModalOpen}
                toggleModal={() => setCommentModalOpen(false)}
                selectedPayout={selectedPayout}
                onUpdated={() => fetchPayouts(filterText, currentPage, perPage)}
            />
        </PageContainer>
    );
};

export default PayoutListing;
